// extracted by mini-css-extract-plugin
export var fullHeightState = "_5p-7";
export var headerCell = "_5p-1";
export var loadingStateCell = "_5p-4";
export var rowWrapper = "_5p-3";
export var standaloneTable = "_5p-8";
export var standaloneTableWithBodyFill = "_5p-9";
export var stateCell = "_5p-5";
export var table = "_5p-0";
export var tableBodyFiller = "_5p-6";
export var white = "_5p-2";